import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Property } from '../../models/property';
import { PropertyAbstract } from '../../models/propertyAbstract';
import { AuthenticationService } from '../../services/AuthenticationService';

@Component({ standalone: false,
  selector: 'bidding-history-dialog',
  templateUrl: 'bidding-history-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager
})
export class BiddingHistoryDialogComponent {
  public title: string= "Bidding History";
  public confirmButtonText = "OK";
  public propertyAbstract?:PropertyAbstract;
  public property?:Property;

  ///this component can take either propertyAbstract or property to be flexible in usage context
  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private dialogRef: MatDialogRef<BiddingHistoryDialogComponent>, private authService:AuthenticationService) {
    if(data){
      this.propertyAbstract=data.pa;
      this.property=data.p;
    }
  }

  /** full history with bidder details, proxy and equalization: super admins only (the server enforces the same) */
  get canSeeAdminBidHistory(){
    return !!this.authService.currentUserValue?.isSuperAdmin;
  }

  public onConfirmClick(): void {
    this.dialogRef.close(true);
  }

  get id(){
    return this.propertyAbstract?this.propertyAbstract.id:this.property!.id;
  }

  get propertyId(){
    return this.propertyAbstract?this.propertyAbstract.propertyId:this.property!.propertyId;
  }

  get propertyIsLive(){
    return (this.propertyAbstract?this.propertyAbstract.isLive:this.property!.auction?.auctionIsLive) ?? false;
  }

  get auctionType(){
    return this.propertyAbstract?this.propertyAbstract.auctionType:this.property!.auction?.auctionType;
  }

  get propertyHeader(){
    return this.propertyAbstract?this.propertyAbstract.header:this.property!.header;
  }

  get auctionId(){
    return this.propertyAbstract?this.propertyAbstract.auctionId:this.property!.auction?.id;
  }
}